// UTM & referrer capture — persists across the browsing session.
// Call captureUtm() on app mount. Call getUtm() when submitting a lead.

const KEY = "ofr_utm_v1";
const UTM_FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const hit = {};
    let touched = false;
    for (const k of UTM_FIELDS) {
      const v = params.get(k);
      if (v) { hit[k] = v; touched = true; }
    }
    if (touched) {
      hit.referrer = document.referrer || "";
      hit.landing_page = window.location.pathname + window.location.search;
      hit.captured_at = new Date().toISOString();
      sessionStorage.setItem(KEY, JSON.stringify(hit));
      return hit;
    }
    // No UTM in URL — if we have nothing stored yet, store bare referrer+landing
    const existing = sessionStorage.getItem(KEY);
    if (!existing) {
      const bare = {
        referrer: document.referrer || "",
        landing_page: window.location.pathname + window.location.search,
        captured_at: new Date().toISOString(),
      };
      sessionStorage.setItem(KEY, JSON.stringify(bare));
      return bare;
    }
    return JSON.parse(existing);
  } catch {
    return {};
  }
}

export function getUtm() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return {};
    const d = JSON.parse(raw);
    // Only pass expected fields to backend
    return {
      utm_source: d.utm_source || "",
      utm_medium: d.utm_medium || "",
      utm_campaign: d.utm_campaign || "",
      utm_content: d.utm_content || "",
      utm_term: d.utm_term || "",
      referrer: d.referrer || "",
      landing_page: d.landing_page || "",
    };
  } catch {
    return {};
  }
}
